import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import GameSubcategoryList from "./GameSubcategoryList";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../services/context";
import {
  getGameCatsList,
  getSubCatPaginatedList,
} from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";

function GameSubCategories() {
  const navigate = useNavigate();
  const { state } = useAppContext();
  const { permissions } = state;
  const [subCategories, setSubCategories] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Game_Sub_Category");
    if (perms) {
      setGranted(perms);
    }
  };
  const getCategories = async () => {
    const res = await getGameCatsList();
    if (res?.data?.success && res?.data?.data) {
      setCategoriesList(res.data.data);
    } else handleErrors(res, navigate, "Categories List:");
  };
  const getSubCategories = async () => {
    const res = await getSubCatPaginatedList();
    if (res?.data?.success && res?.data?.data) {
      setSubCategories(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else handleErrors(res, navigate, "Sub-Categories List:");
  };
  useEffect(() => {
    extractPermissions();
    getSubCategories();
    getCategories();
  }, []);
  return (
    <DashboardLayout>
      <div>
        <div className="col-12 mb-3">
          <div className="page-title-box d-sm-flex">
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a>System Settings</a>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#8b8b8cbf" }}
                >
                  Game Sub Category
                </li>
              </ol>
            </div>
          </div>
        </div>

        <GameSubcategoryList
          subCategories={subCategories}
          setSubCategories={setSubCategories}
          pagination={pagination}
          setPagination={setPagination}
          categoriesList={categoriesList}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
}

export default GameSubCategories;
